/* eslint-disable @typescript-eslint/no-explicit-any */
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {AuthConfigService} from '../services/auth-config.service';

@Injectable()
export class AuthOidcInterceptor implements HttpInterceptor {
  private readonly authConfigService = inject(AuthConfigService);
  private readonly router = inject(Router);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const apiDomain = this.extractDomain(request.url);
    const routeUrl = this.router.url;

    if (
      (this.authConfigService.isTokenValid() && apiDomain == this.extractDomain(environment.api.baseUrl)) ||
      routeUrl.includes('account-confirmation')
    ) {
      const modifiedRequest = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.authConfigService.getAccessToken()}`,
        },
      });
      return next.handle(modifiedRequest);
    } else {
      return next.handle(request);
    }
  }

  private extractDomain(url: string): string {
    if (this.isValidUrl(url)) {
      const parsedUrl = new URL(url);
      const domain = parsedUrl.hostname;
      return domain.replace(/^www\./, '');
    }
    return url;
  }

  private isValidUrl(url: string) {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  }
}
